import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import HashgraphDevHero from "./HashgraphDevHero";
import GossipProtocol from "./GossipProtocol";
import HederaHashgraph from "./HederaHashgraph";

function HashgraphDevelopment() {
  return (
    <div>
      <Header />
      <HashgraphDevHero />
      <GossipProtocol />
      <HederaHashgraph />
      <Footer />
    </div>
  );
}

export default HashgraphDevelopment;
